export const KB = 1024
export const MB = KB * 1024
export const GB = MB * 1024

/**
 * Blocked file types - executables and scripts that should never be uploaded
 * Includes both MIME types and file extensions
 */
export const BLOCKED_FILE_TYPES = {
    mimeTypes: [
        // Executables
        "application/x-msdownload",
        "application/x-executable",
        "application/x-msdos-program",
        "application/x-msi",
        "application/x-apple-diskimage",
        "application/vnd.microsoft.portable-executable",
        // Scripts
        "application/javascript",
        "text/javascript",
        "application/x-javascript",
        "application/x-php",
        "application/x-httpd-php",
        "text/x-php",
        "application/x-python",
        "text/x-python",
        "application/x-sh",
        "application/x-shellscript",
        "text/x-shellscript",
        "application/x-perl",
        "text/x-perl",
        "application/x-ruby",
        "text/x-ruby",
        // Batch files
        "application/bat",
        "application/x-bat",
        "application/x-msdos-program",
        // Dynamic libraries
        "application/x-sharedlib",
    ],
    extensions: [
        // Windows executables
        "exe",
        "msi",
        "bat",
        "cmd",
        "com",
        "scr",
        "pif",
        "vbs",
        "vbe",
        "ws",
        "wsf",
        "wsc",
        "wsh",
        "ps1",
        "psm1",
        "psd1",
        // macOS executables
        "app",
        "dmg",
        "pkg",
        "command",
        // Linux executables
        "sh",
        "bash",
        "zsh",
        "run",
        "bin",
        // Scripts
        "js",
        "mjs",
        "cjs",
        "php",
        "php3",
        "php4",
        "php5",
        "phtml",
        "py",
        "pyc",
        "pyo",
        "pyw",
        "pl",
        "pm",
        "rb",
        "rbw",
        // Dynamic libraries
        "dll",
        "so",
        "dylib",
        // Other dangerous
        "jar",
        "jse",
        "reg",
        "inf",
        "hta",
        "cpl",
        "msc",
        "lnk",
        "scf",
        "url",
    ],
} as const
